/**
* DevExpress Analytics (query-builder\elements\allColumnsModelMeta.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { name, selected } from '../metadata';
export const allColumnsSerializationInfo = [name, selected];
